import classNames from 'classnames'

import { Quantity } from './Quantity'
import { RemoveButton } from './RemoveButton'
import { BasketLineActionBarProps } from './types'
import { AddToWishlist } from '@/features/product/components/AddToWishlist'
import { GiftWrapPlugin } from '../../../../cart/plugins'
import { useCartPlugin } from '../../../../cart/hooks'
import { useMemo } from 'react'

export const BasketLineActionBar = ({
  isDesktop,
  isSet,
  lineItemKeys,
  productId,
  quantity,
  className,
  giftCard,
  showQuantity = true,
}: BasketLineActionBarProps) => {
  return (
    <div
      className={classNames(
        'flex items-center w-full gap-2',
        showQuantity ? 'justify-between' : 'justify-end',
        className,
      )}
    >
      {showQuantity && (
        <Quantity
          isDesktop={isDesktop}
          isSet={isSet}
          lineItemKeys={lineItemKeys}
          quantity={quantity}
        />
      )}
      <div
        className="flex flex-row items-center gap-2 text-neutral-100 text-sm"
        data-testid="line-action-bar"
      >
        {!giftCard && (
          <>
            <AddToWishlist
              productId={productId}
              className="w-6 h-6 [&>svg]:w-3 [&>svg]:h-3"
            />
            |
          </>
        )}
        <RemoveButton lineItemKeys={lineItemKeys} />
      </div>
    </div>
  )
}
